"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var React = require("react");

var FaChevronDown_1 = require("@react-icons/all-files/fa/FaChevronDown");

var FaTimes_1 = require("@react-icons/all-files/fa/FaTimes");

var downshift_1 = require("downshift");

var styled_components_1 = require("styled-components");

var Form_1 = require("./Form");

var utils_1 = require("../utils");

var Menu = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var isOpen = _a.isOpen,
      theme = _a.theme,
      variant = _a.variant,
      size = _a.size;
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'Select', variant, size);
  return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      box-sizing: border-box;\n      position: absolute;\n      background-color: ", ";\n      max-height: 20rem;\n      width: 100%;\n      overflow-y: auto;\n      overflow-x: hidden;\n      outline: 0;\n      transition: opacity 0.1s ease;\n      border-radius: 0 0 4px 4px;\n      box-shadow: ", ";\n      border: none;\n      z-index: 10;\n\n      ", "\n    "], ["\n      box-sizing: border-box;\n      position: absolute;\n      background-color: ", ";\n      max-height: 20rem;\n      width: 100%;\n      overflow-y: auto;\n      overflow-x: hidden;\n      outline: 0;\n      transition: opacity 0.1s ease;\n      border-radius: 0 0 4px 4px;\n      box-shadow: ", ";\n      border: none;\n      z-index: 10;\n\n      ", "\n    "])), themeStyles.backgroundColor, themeStyles.shadowColor, isOpen && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          border: 1px solid ", ";\n          border-top: none;\n        "], ["\n          border: 1px solid ", ";\n          border-top: none;\n        "])), themeStyles.borderColor));
});
var MenuItem = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var isSelected = _a.isSelected,
      isActive = _a.isActive,
      theme = _a.theme,
      variant = _a.variant,
      size = _a.size;
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'Select', variant, size);
  return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      background: white;\n      color: ", ";\n      cursor: pointer;\n\n      ", "\n\n      ", "\n      ", "\n    "], ["\n      background: white;\n      color: ", ";\n      cursor: pointer;\n\n      ", "\n\n      ", "\n      ", "\n    "])), theme.colors.greyDark, isActive && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), theme.colors.greyLighter), isSelected && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          background-color: ", ";\n          color: white;\n        "], ["\n          background-color: ", ";\n          color: white;\n        "])), theme.colors.primary), themeStyles);
});
var ControllerButton = styled_components_1.default.button(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
      disabled = _a.disabled,
      isOpen = _a.isOpen,
      size = _a.size,
      variant = _a.variant;
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'Select', variant, size);
  return styled_components_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    color: ", ";\n    position: absolute;\n    right: 0;\n    top: 0;\n    box-shadow: none;\n    border: none;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color transparent;\n    padding: 0 1rem;\n    cursor: pointer;\n    outline: 0;\n\n    ", "\n\n    ", "\n  "], ["\n    color: ", ";\n    position: absolute;\n    right: 0;\n    top: 0;\n    box-shadow: none;\n    border: none;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color transparent;\n    padding: 0 1rem;\n    cursor: pointer;\n    outline: 0;\n\n    ", "\n\n    ", "\n  "])), themeStyles.color, disabled && styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        color: ", ";\n        cursor: not-allowed;\n        pointer-events: none;\n      "], ["\n        color: ", ";\n        cursor: not-allowed;\n        pointer-events: none;\n      "])), themeStyles.disabledColor), isOpen && styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        transform: rotate(180deg);\n      "], ["\n        transform: rotate(180deg);\n      "]))));
});

function Select(_a) {
  var _b = _a.options,
      options = _b === void 0 ? [] : _b,
      _c = _a.label,
      label = _c === void 0 ? null : _c,
      _d = _a.name,
      name = _d === void 0 ? null : _d,
      _e = _a.size,
      size = _e === void 0 ? 'md' : _e,
      _f = _a.placeholder,
      placeholder = _f === void 0 ? null : _f,
      _g = _a.value,
      value = _g === void 0 ? '' : _g,
      _h = _a.onChange,
      onChange = _h === void 0 ? function () {
    return {};
  } : _h,
      isDisabled = _a.disabled,
      _j = _a.isClearable,
      isClearable = _j === void 0 ? false : _j,
      _k = _a.isFilterable,
      isFilterable = _k === void 0 ? false : _k,
      _l = _a.isRequired,
      isRequired = _l === void 0 ? false : _l,
      variant = _a.variant,
      error = _a.error,
      rest = __rest(_a, ["options", "label", "name", "size", "placeholder", "value", "onChange", "disabled", "isClearable", "isFilterable", "isRequired", "variant", "error"]);

  var handleChange = function handleChange(selection) {
    if (selection && typeof onChange === 'function') {
      onChange(name, selection.value);
    }
  };

  var getLabel = function getLabel() {
    var option = options.find(function (o) {
      return o.value === value;
    });
    return option ? option.label.toString() : '';
  };

  var theme = styled_components_1.useTheme();
  var menuStyles = utils_1.getComponentThemeStyles(theme, 'Select', variant, size);
  return React.createElement(downshift_1.default, {
    onChange: handleChange,
    itemToString: function itemToString(option) {
      return option && option.label;
    },
    initialInputValue: getLabel()
  }, function (_a) {
    var getInputProps = _a.getInputProps,
        getItemProps = _a.getItemProps,
        getMenuProps = _a.getMenuProps,
        getToggleButtonProps = _a.getToggleButtonProps,
        clearSelection = _a.clearSelection,
        inputValue = _a.inputValue,
        isOpen = _a.isOpen,
        highlightedIndex = _a.highlightedIndex,
        selectedItem = _a.selectedItem;

    var filterOptions = function filterOptions(option) {
      var lowerCaseOptionValue = option.value.toString().toLowerCase();
      var lowerCaseOptionLabel = option.label.toString().toLowerCase();
      var lowerCaseInputValue = inputValue ? inputValue.toString().toLowerCase() : '';
      return !lowerCaseInputValue || lowerCaseOptionValue.includes(lowerCaseInputValue) || lowerCaseOptionLabel.includes(lowerCaseInputValue);
    };

    var renderOptions = function renderOptions() {
      var optionsToRenders = options;

      if (isFilterable) {
        optionsToRenders = options ? options.filter(filterOptions) : options;
      }

      return optionsToRenders.map(function (item, index) {
        return React.createElement(MenuItem, __assign({
          key: item.value
        }, getItemProps({
          item: item,
          index: index,
          isSelected: selectedItem === options[index],
          disabled: isDisabled
        }), {
          size: size,
          variant: variant,
          isActive: highlightedIndex === index
        }), item.label);
      });
    };

    var buttonProps = getToggleButtonProps({
      disabled: isDisabled
    });
    return React.createElement("div", {
      style: {
        position: 'relative'
      }
    }, React.createElement("div", __assign({
      style: {
        position: 'relative'
      }
    }, buttonProps, rest), React.createElement(Form_1.Input, __assign({}, getInputProps({
      disabled: isDisabled || !isFilterable,
      placeholder: placeholder,
      value: inputValue != null ? inputValue : '',
      name: name,
      label: label
    }), {
      size: size,
      required: isRequired,
      error: error,
      style: {
        color: menuStyles.color,
        backgroundColor: menuStyles.backgroundColor,
        borderRadius: menuStyles.borderRadius
      }
    })), selectedItem && isClearable ? React.createElement(ControllerButton, {
      onClick: function onClick(e) {
        e.stopPropagation();
        clearSelection();
      },
      "aria-label": "clear selection",
      size: size
    }, React.createElement(FaTimes_1.FaTimes, {
      color: menuStyles.color
    })) : React.createElement(ControllerButton, {
      isOpen: isOpen,
      size: size
    }, React.createElement(FaChevronDown_1.FaChevronDown, {
      color: menuStyles.color
    }))), React.createElement(Menu, __assign({}, getMenuProps(), {
      isOpen: isOpen,
      variant: variant,
      size: size
    }), isOpen ? renderOptions() : null));
  });
}

exports.Select = Select;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;